/**
 * App-facing helpers for building language-aware internal links.
 *
 * Internal links are built from a route KEY, never from a hardcoded path: the
 * English and the Spanish slug of a page are different words, and only
 * `src/seo/routes.js` knows both.
 *
 *   <Link to={localizedPath('privacy', lang)}>...</Link>
 */
import routes from '../seo/routes';

export const {
  localizedPath,
  routeFromPath,
  mirrorPath,
  alternates,
  langFromPath,
  normalize,
  LANGS,
  DEFAULT_LANG,
  ES_PREFIX,
} = routes;

export default localizedPath;
